import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';
import { UserDashboardType } from '@features/users/enums';

export class UserDashboard extends Model {
  @Expose() url: string;
  @Expose() name: string;
  @Expose() type: UserDashboardType;
  @Expose() token: string;
}
